import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';

const GiftCardsLookup = ({ value, onChange, search }) => (
  <div>
    <form onSubmit={search} className="u-flex">
      <div>
        <input
          className="c-input c-input--search c-input--white u-width-400"
          placeholder={t('register:gift_cards.lookup.placeholder')}
          type="text"
          value={value}
          onChange={onChange}
        />
      </div>
      <button className="c-btn c-btn--medium u-width-120 u-ml" type="submit">
        {t('register:gift_cards.lookup.search_button')}
      </button>
    </form>
  </div>
);
GiftCardsLookup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
};

export default GiftCardsLookup;
